import React from 'react';

const OtherEdit = ({ setData, data }) => {



   
    return (
        <div className="container">
            <h2 className="appeal-title mb-5">Друга преписка</h2>
            <div className="form-row">

                <div className="form-group col-md-2">
                    <label>Номер на обект</label>
                    <input type="text" className="form-control" value={data.objectNumber} onChange={(e) => setData("objectNumber", e.target.value)} />
                </div>

                <div className="form-group col-md-10">
                    <label>Заглавие</label>
                    <input type="text" className="form-control" value={data.title} onChange={(e) => setData("title", e.target.value)} />
                </div>
                

                
            </div>
        </div>

    );
}


export default OtherEdit;